export default class BrowserPermissionsError extends Error {
  permission: NotificationPermission;

  constructor(message: string, permission: NotificationPermission) {
    super(message);
    this.name = 'BrowserPermissionsError';
    this.permission = permission;

    Object.setPrototypeOf(this, BrowserPermissionsError.prototype);
  }

  static isBrowserPermissionsError(error: unknown): error is BrowserPermissionsError {
    if (typeof error !== 'object' || error === null || !('permission' in error)) {
      return false;
    }

    const browserPermissionsError = error as BrowserPermissionsError;

    return (
      typeof browserPermissionsError.permission === 'string' &&
      ['granted', 'denied', 'default'].includes(browserPermissionsError.permission)
    );
  }
}
